import React from 'react';
import { email, required } from '@src/validation';
import Style from '@src/components/Login/Login.module.scss';
import Logo from '@assets/images/logo.png';
import { Alert, Container } from 'reactstrap';
import LabelInput from '@components/LabelInput/LabelInput';
import SuccessPage from './SuccessPage/SuccessPage';
import { Link } from 'react-router-dom';

import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';

const fieldValidator = {
  email: [required, email]
};

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};
    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: '',
        visited: false,
        error: false
      };

      props.onReset();
    });

    this.state = { ...fields, submitted: false };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }
    this.setState({
      [name]: inputData
    });
  };

  submitHandler = event => {
    event.preventDefault();

    const registrationData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;
    Object.keys(fieldValidator).forEach(key => {
      postData[key] = registrationData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        console.log(registrationData[key].value);
        const validationMsg = fieldValidator[key][i](
          registrationData[key].value
        );
        registrationData[key].visited = true;
        if (validationMsg !== undefined) {
          registrationData[key].error = validationMsg;
          isValid = false;
          break;
        }
      }
    });
    this.setState({ ...registrationData });

    if (isValid) {
      this.props.onSubmit(registrationData.email.value);
    }
    return false;
  };

  render = () => {
    return (
      <Container fluid={true} className={'h-100 text-center'}>
        {this.props.success ? (
          <SuccessPage />
        ) : (
          <form
            className={Style['form-signin'] + ' p-4'}
            onSubmit={this.submitHandler}
          >
            <img className="mb-4" src={Logo} alt="Logos" style={{width: '200px'}} />
            <h1 className="h3 mb-3 font-weight-normal">NXT Insurance Hub</h1>
            <p>Forgot Your Password?</p>
            <p>We’l email you instructions to reset your password.</p>
            {this.props.error !== null && (
              <div>
                <Alert color={'danger'}>{this.props.error}</Alert>
              </div>
            )}
            <LabelInput
              placeholder={'Email Address'}
              type={'text'}
              required={true}
              {...this.state.email}
              onChange={event => this.updateForm(event, 'email')}
            />
            <button
              className="btn btn-lg btn-primary btn-block mb-2"
              type="submit"
            >
              Reset Password
            </button>
            <hr />
            <div>
              Already have an account? <Link to={'/'}>Login</Link>
            </div>
          </form>
        )}
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    error: state.forgotPassword.error,
    success: state.forgotPassword.success
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: email => dispatch(actions.forgotPasswordRequest(email)),
    onReset: () => dispatch(actions.resetForgotPasswordState())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword);
